<div id="wachtwoorddlg">
  <img id="wachtwoordlogo" alt="ATR" class="d-block mx-auto" src="../assets/img/atr_logo.png">

  @if (weergave === 'aanvragen') {
    <h1>Wachtwoord vergeten</h1>
    <p>Vul je e-mailadres in. Je krijgt een mail met een link waarmee je een nieuw wachtwoord kunt
      instellen.</p>
    <form #vergetenForm="ngForm" (ngSubmit)="vraagAan()">
      <div class="form-group">
        <label for="wwemail">E-mailadres</label>
        <input type="email" class="form-control" email spellcheck="false" autocomplete="email"
               name="wwemail" id="wwemail" required [(ngModel)]="email">
      </div>
      <div class="text-center">
        <button class="btn btn-primary" type="submit" [disabled]="bezig || !vergetenForm.form.valid">
          Stuur me een link
        </button>
      </div>
    </form>
  } @else {
    <h1>Nieuw wachtwoord</h1>
    @if (!gecontroleerd) {
      <p>Even kijken of de link nog werkt...</p>
    } @else if (!geldig) {
      <p>Deze link werkt niet meer. Dat kan twee dingen betekenen: hij is verlopen, of er is al een
        nieuw wachtwoord mee ingesteld.</p>
      <div class="text-center">
        <button class="btn btn-primary" type="button" (click)="weergave = 'aanvragen'">
          Vraag een nieuwe link aan
        </button>
      </div>
    } @else {
      <p>Kies een nieuw wachtwoord van minstens {{ minlengte }} tekens.</p>
      <form #instelForm="ngForm" (ngSubmit)="instellen()">
        <div class="form-group">
          <label for="wwinstelemail">E-mailadres</label>
          <input type="email" class="form-control" email spellcheck="false" autocomplete="email"
                 name="wwinstelemail" id="wwinstelemail" [(ngModel)]="email">
          <small>Je stelt hiermee het wachtwoord in van het account waarvoor deze link is aangevraagd,
            wat hier ook staat. Vul het e-mailadres van dát account in, dan ben je meteen ingelogd.</small>
        </div>
        <div class="form-group">
          <label for="wwnieuw">Nieuw wachtwoord</label>
          <input type="password" class="form-control" autocomplete="new-password"
                 name="wwnieuw" id="wwnieuw" required [minlength]="minlengte" [(ngModel)]="nieuw">
        </div>
        <div class="form-group">
          <label for="wwherhaling">Nog een keer</label>
          <input type="password" class="form-control" autocomplete="new-password"
                 name="wwherhaling" id="wwherhaling" required [(ngModel)]="herhaling">
          @if (herhaling && nieuw !== herhaling) {
            <small class="fout">De twee wachtwoorden zijn niet gelijk.</small>
          }
        </div>
        <div class="text-center">
          <button class="btn btn-primary" type="submit" [disabled]="bezig || !klopt">
            Wachtwoord instellen
          </button>
        </div>
      </form>
    }
  }

  <div class="text-center mt-3">
    <a class="terug" (click)="terug()">Terug naar inloggen</a>
  </div>
  <div class="appname"><span class="atr">ATR</span><span class="plan">plan</span></div>
</div>
